<template>
    <div>
        <section class="py-2 py-md-3">
            <div class="container">
                <div class="breadcrumbs-retos py-5 d-none d-md-block">
                    <a href="/home-bat">Inicio /</a>
                    <a href="/retos?learning">A la práctica /</a>
                    <span v-if="learning !== null">{{ learning.title }}</span>
                </div>
            </div>
        </section>

        <div class="container pb-5 datos">
            <div v-if="learning !== null">
                <h2 class="titleModulo" v-if="learning">{{ learning.title }} <span v-if="status === 'completed'" class="text-success"><i class="fa-solid fa-circle-check"></i> Completado</span></h2>
                <p>
                    {{ learning.description }}
                </p>
            </div>
            <div class="row">
                <div class="col-12 col-md-1 avance reto-mobile pt-3">
                    <ul class="nav nav-pills mb-3 content-pasos d-flex justify-content-between justify-content-md-center pb-4 pb-md-0 mb-md-0">
                        <li v-for="content in contents" role="presentation">
                            <div :class="step === content.step ? 'progreso' : step > content.step ? 'active' : ''" id="pills-home-tab">
                                <div class="paso text-center">
                                    <div class="icon">
                                    </div>
                                    <p>
                                        Lección {{ content.step }}
                                    </p>
                                    <p class="sub">
                                        {{ content.title }}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="current_content !== null" class="col-12 col-md-11">
                    <p class="title-aprendizaje">Lección {{ step }}: {{ current_content.title }}</p>
                    <div class="bannerModule pb-5">
                        <iframe v-if="current_content.video"
                            :src="current_content.video+'&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                            style="width:100%;height:100%;" frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                        <img v-else-if="current_content.image" :src="url_storage+'storage/'+JSON.parse(current_content.image)[0]" :alt="current_content.title" class="w-100">
                    </div>
                    <div class="content-two-cols mb-3">
                        <article class="content" v-html="current_content.content"></article>
                    </div>
                    <div class="row">
                        <div class="col-6 d-flex justify-content-center justify-content-md-start">
                            <div v-if="step > 1" @click="previewsStep" class="button button-underline">Anterior</div>
                            <div v-else class="button button-underline disabled">Anterior</div>
                        </div>
                        <div class="col-6 d-flex justify-content-end">
                            <div v-if="step < contents.length" @click="nextStep" class="button button-blue px-5">Siguiente</div>
                            <div v-else @click="finishLearning" class="button button-blue px-5">Finalizar</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="modal_finish"
            :width="$mq === 'sm' ? '90%' : '40%'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false">
            <div class="align-items-center text-center flex-column justify-content-center" v-if="learning">
                <img src="/img-version2/modal/tick-circle.svg" alt="image 8">
                <h4>¡Felicitaciones!</h4>
                <p>Completaste todas las lecciones del modulo <br> {{ learning.title }}</p>
                <a href="/retos?learning" class="button button-blue px-5">Aceptar</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        learning: {
            default: null,
        },
        contents: {
            default: null,
        },
        url_storage: {
            default: null,
        },
        status: {
            default: 'pending',
        }
    },
    data() {
        return {
            loading: 0,
            step: 1,
            current_content: null,
            modal_finish: false,
            first_time: true,
        }
    },
    mounted () {
        if(this.contents.length > 0){
            this.current_content = this.contents[0]
        }
    },
    methods: {
        nextStep() {
            this.current_content = this.contents[this.step]
            this.step++
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });
        },
        previewsStep() {
            this.step--
            this.current_content = this.contents[this.step-1]
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });
        },
        finishLearning(){
            this.loading++
            axios.post(`/learning/${this.learning.id}/finish`).then(
                ({data}) => {
                    this.modal_finish = true
                    this.loading--
                })
        }
    },
}
</script>